export default "__VITE_ASSET__CBC$EUw___"